import React from "react";
import InputField from "components/styledFormElements/InputField";
import { useFormContext } from "react-hook-form";
import { OnboardingFormValues } from "containers/Protected/Settings/OnboardingSettings/interface";

const SplashScreenSettings: React.FC = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext<OnboardingFormValues>();

  return (
    <div className="settings-card">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <InputField
          label="Title"
          required
          helpText='Main heading displayed on the phone number entry screen (e.g., "Enter phone number")'
          placeholder="Enter Title"
          type="text"
          register={register("splash.s_title")}
          error={errors?.splash?.s_title?.message}
        />
        <InputField
          label="Sub Title"
          required
          helpText='Supporting text shown below the title explaining the action (e.g., "We will send an OTP to verify you").'
          placeholder="Enter Sub Title"
          type="text"
          register={register("splash.s_subTitle")}
          error={errors?.splash?.s_subTitle?.message}
        />
      </div>
    </div>
  );
};

export default SplashScreenSettings;
